import React from "react";
import { Link } from "react-router-dom";

import { useView } from "../../context/ViewContext";
import { useActiveBusiness } from "../../hooks/useActiveBusiness";
import { canUseProfessionalFeatures } from "../../utils/roleCapabilities";
import { DEFAULT_DASHBOARD_PATH } from "../../utils/workspaceAuthorization";
import "./NotFound.css";


const NotFound = () => {
  // The view and workspace contexts already resolve the session for the rest of
  // the shell, so the dashboard link follows them instead of re-reading storage.
  const { currentView } = useView() || {};
  const { capabilities: workspaceCapabilities, payload } = useActiveBusiness();

  const hasWorkspaceAccess = Boolean(
    workspaceCapabilities?.isWorkspaceMember || payload?.businessWorkspaceAccess
  );
  const showDashboardLink =
    hasWorkspaceAccess ||
    currentView === "professional" ||
    canUseProfessionalFeatures(payload?.role);
  const dashboardPath =
    workspaceCapabilities?.workspaceLandingPath || DEFAULT_DASHBOARD_PATH;

  return (
    <div className="notfound-shell">
      <section className="notfound-layout" aria-labelledby="notfound-title">
        <p className="notfound-code" aria-hidden="true">
          404
        </p>

        <span className="notfound-chip">Page not found</span>

        <h1 className="notfound-title" id="notfound-title">
          This page doesn&rsquo;t exist
        </h1>

        <p className="notfound-copy">
          The link may be out of date, or the address might have a typo. Nothing
          is broken on your account &mdash; pick a place to head back to below.
        </p>

        <div className="notfound-actions">
          <Link className="notfound-btn notfound-btn-primary" to="/">
            Go to home
          </Link>
          {showDashboardLink && (
            <Link className="notfound-btn notfound-btn-outline" to={dashboardPath}>
              Go to dashboard
            </Link>
          )}
        </div>

        <p className="notfound-meta">
          Still stuck? <Link to="/help">Visit the Help Center</Link>.
        </p>
      </section>
    </div>
  );
};

export default NotFound;
